import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "../styles/OTP.css";
import logo from "../assets/a0b9f44cc8f2da963034bf8a0849385a074bd917.png";
import API_BASE_URL from ".././config/env";

const OTP: React.FC = () => {
  const [otp, setOtp] = useState(Array(4).fill(""));
  const inputsRef = useRef<HTMLInputElement[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const phone = localStorage.getItem("gp_phone");

  const handleChange = (value: string, index: number) => {
    if (/^[0-9]?$/.test(value)) {
      const updated = [...otp];
      updated[index] = value;
      setOtp(updated);
      if (value && index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const otpValue = otp.join("");
    if (otpValue.length !== 4) {
      alert("Enter valid 4-digit OTP");
      return;
    }

    setLoading(true);

    try {
      const res = await axios.post(`${API_BASE_URL}/api/global-partner-verify-otp`, {
        mobile_number: phone,
        otp: otpValue,
      });

      if (res.data.status === "success") {
        localStorage.setItem("authToken", res.data.token);
        localStorage.setItem("auth", "true");
        localStorage.setItem("gp_token", res.data.token);
        localStorage.setItem("gp_phone", phone || "");
        
        localStorage.setItem("gp_user", JSON.stringify(res.data.user));
        
        navigate("/dashboard");
      }
    } catch (err: any) {
      alert(err.response?.data?.message || "Invalid OTP");
    }

    setLoading(false);
  };

  return (
    <div className="otp-wrapper">
      <div className="otp-card">
        <img src={logo} className="logo" alt="logo" />
        <h2 className="title">Enter Verification Code</h2>
        <p className="sub-text">Enter the code sent to {phone}</p>

        <form onSubmit={handleSubmit}>

          <div className="otp-container">
            {otp.map((digit, i) => (
              <input
                key={i}
                maxLength={1}
                value={digit}
                onChange={(e) => handleChange(e.target.value, i)}
                ref={(el) => {
                  if (el) inputsRef.current[i] = el;
                }}
              />
            ))}
          </div>

          <p className="link change-number" onClick={() => navigate("/")}>
            Change phone number
          </p>

          <button type="submit" disabled={loading}>
            {loading ? "Verifying..." : "Verify & Login"}
          </button>
        </form>

        <p className="register-text">
          Don't have an account? <Link to="/register/form" className="link">Register</Link>
        </p>
      </div>
    </div>
  );
};

export default OTP;